import React from 'react';

export default function NotFoundPage() {
    return <main>404! Page not found.</main>
}
